import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ProfissionalEditarRoutingModule } from "./profissional-editar-routing.module";
import { ProfissionalEditarComponent } from "./profissional-editar.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import { TabViewModule } from "primeng/tabview";
import { InputSwitchModule } from "primeng/inputswitch";
import { TableModule } from "primeng/table";
import { InputNumberModule } from "primeng/inputnumber";
import { DialogModule } from "primeng/dialog";
import { CheckboxModule } from "primeng/checkbox";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TreeTableModule } from "primeng/treetable";
import { ProgressSpinnerModule } from "primeng/progressspinner";


@NgModule({
    imports: [
        CommonModule,            
        ProfissionalEditarRoutingModule,
        HttpClientModule,        
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DividerModule,
        DropdownModule,
        FormsModule,
        InputTextareaModule,
        InputMaskModule,
        MessagesModule,
        TabViewModule,
        InputSwitchModule,
        TableModule,
        InputNumberModule,
        DialogModule,
        CheckboxModule,
        FormatPipeModule,
        ConfirmDialogModule,
        TreeTableModule,
        ProgressSpinnerModule
    ],
    providers: [ConfirmationService],
    declarations: [ProfissionalEditarComponent]
})
export class ProfissionalEditarModule { }
